"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOutput = exports.asyncForEach = exports.getInputList = exports.getInspectArgs = exports.getCreateArgs = exports.getBuilderName = exports.getInputs = exports.tmpNameSync = exports.tmpDir = exports.osArch = exports.osPlat = void 0;
const fs_1 = __importDefault(require("fs"));
const os = __importStar(require("os"));
const path_1 = __importDefault(require("path"));
const tmp = __importStar(require("tmp"));
const uuid = __importStar(require("uuid"));
const buildx = __importStar(require("./buildx"));
const core = __importStar(require("@actions/core"));
const command_1 = require("@actions/core/lib/command");
let _tmpDir;
exports.osPlat = os.platform();
exports.osArch = os.arch();
function tmpDir() {
    if (!_tmpDir) {
        _tmpDir = fs_1.default.mkdtempSync(path_1.default.join(os.tmpdir(), 'docker-setup-buildx-')).split(path_1.default.sep).join(path_1.default.posix.sep);
    }
    return _tmpDir;
}
exports.tmpDir = tmpDir;
function tmpNameSync(options) {
    return tmp.tmpNameSync(options);
}
exports.tmpNameSync = tmpNameSync;
function getInputs() {
    return __awaiter(this, void 0, void 0, function* () {
        return {
            version: core.getInput('version'),
            name: getBuilderName(core.getInput('driver') || 'docker-container'),
            driver: core.getInput('driver') || 'docker-container',
            driverOpts: yield getInputList('driver-opts', true),
            buildkitdFlags: core.getInput('buildkitd-flags') || '--allow-insecure-entitlement security.insecure --allow-insecure-entitlement network.host',
            install: core.getBooleanInput('install'),
            use: core.getBooleanInput('use'),
            endpoint: core.getInput('endpoint'),
            config: core.getInput('config'),
            configInline: core.getInput('config-inline')
        };
    });
}
exports.getInputs = getInputs;
function getBuilderName(driver) {
    return driver == 'docker' ? 'default' : `builder-${uuid.v4()}`;
}
exports.getBuilderName = getBuilderName;
function getCreateArgs(inputs, buildxVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const args = ['create', '--name', inputs.name, '--driver', inputs.driver];
        if (buildx.satisfies(buildxVersion, '>=0.3.0')) {
            yield (0, exports.asyncForEach)(inputs.driverOpts, (driverOpt) => __awaiter(this, void 0, void 0, function* () {
                args.push('--driver-opt', driverOpt);
            }));
            if (inputs.driver != 'remote' && inputs.buildkitdFlags) {
                args.push('--buildkitd-flags', inputs.buildkitdFlags);
            }
        }
        if (inputs.use) {
            args.push('--use');
        }
        if (inputs.driver != 'remote') {
            if (inputs.config) {
                args.push('--config', yield buildx.getConfigFile(inputs.config));
            }
            else if (inputs.configInline) {
                args.push('--config', yield buildx.getConfigInline(inputs.configInline));
            }
        }
        if (inputs.endpoint) {
            args.push(inputs.endpoint);
        }
        return args;
    });
}
exports.getCreateArgs = getCreateArgs;
function getInspectArgs(inputs, buildxVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const args = ['inspect', '--bootstrap'];
        if (buildx.satisfies(buildxVersion, '>=0.4.0')) {
            args.push('--builder', inputs.name);
        }
        return args;
    });
}
exports.getInspectArgs = getInspectArgs;
function getInputList(name, ignoreComma) {
    return __awaiter(this, void 0, void 0, function* () {
        const items = core.getInput(name);
        if (items == '') {
            return [];
        }
        return items
            .split(/\r?\n/)
            .filter(x => x)
            .reduce((acc, line) => acc.concat(!ignoreComma ? line.split(',').filter(x => x) : line).map(pat => pat.trim()), []);
    });
}
exports.getInputList = getInputList;
const asyncForEach = (array, callback) => __awaiter(void 0, void 0, void 0, function* () {
    for (let index = 0; index < array.length; index++) {
        yield callback(array[index], index, array);
    }
});
exports.asyncForEach = asyncForEach;
// FIXME: Temp fix https://github.com/actions/toolkit/issues/777
function setOutput(name, value) {
    (0, command_1.issueCommand)('set-output', { name }, value);
}
exports.setOutput = setOutput;
